let requestId = 0;
const pending = {};

window.handleNativeMessage = (data) => {
  try {
    const { _promiseId, result, error } = data;
    if (pending[_promiseId]) {
      if (error) {
        pending[_promiseId].reject(new Error(error));
      } else {
        pending[_promiseId].resolve(result);
      }
      delete pending[_promiseId];
    }
  } catch (err) {
    console.error("Erro ao processar mensagem do RN:", err);
  }
};

export const sendToNative = (command) => {
  return new Promise((resolve, reject) => {
    if (!window?.ReactNativeWebView?.postMessage) {
      return resolve(null);
    }
    const _promiseId = ++requestId;
    pending[_promiseId] = { resolve, reject };
    window.ReactNativeWebView.postMessage(JSON.stringify({ _promiseId, ...command }));
  });
};